<template>
  <v-card-text>
    <v-data-iterator :items="denunciations" :items-per-page="10" :page="1">
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            lg="3"
            md="6"
            sm="12"
          >
            <CardDenunciations
              :item="item"
              :srcImage="loadImage(item.img_release)"
              @edit="$emit('edit', item)"
              @remove="$emit('remove', item)"
            ></CardDenunciations>

          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-card-text>
</template>

<script>
import CardDenunciations from "@/components/cards/CardDenunciations.vue";
import { loadAPIImage } from "@/utils/images";
export default {
  components: {
    CardDenunciations,
  },
  props: {
    denunciations: Array,
  },
  methods: {
    loadImage(src) {
      return loadAPIImage(src);
    },
  },
};
</script>

<style lang="scss" scoped></style>
